import { Followup } from '../types/FollowUp';
import { toCamelCase, toSnakeCase } from '../utils/caseConverter';
import { getApiHeaders } from '../utils/apiHeaders';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchFollowups = () => {
  return fetch(`${API_BASE_URL}/api/followups`, {
        headers: getApiHeaders('none')
      }).then(res => res.json()).then(data => toCamelCase(data));
};

export const fetchFollowupsByDate = (date: string) => {
  const url = new URL(`${API_BASE_URL}/api/followups`);
  url.searchParams.set('date', date);
  return fetch(url.toString(), {
    headers: getApiHeaders('none')
  }).then(res => res.json()).then(data => toCamelCase(data));
};

export async function createFollowUp(data: Followup): Promise<{ id: number }> {
  const res = await fetch(`${API_BASE_URL}/api/followups`, {
    method: 'POST',
    headers: getApiHeaders('json'),
    body: JSON.stringify(toSnakeCase(data)),
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to create followup: ${errorText}`);
  }

  return res.json();
}

export const fetchFollowupsForAQuery = (queryID: number) => {
  return fetch(`${API_BASE_URL}/api/followups/query/${queryID}`, {
            headers: getApiHeaders('none')
         }).then(res => res.json()).then(data => toCamelCase(data));
};

export const fetchFollowupsForToday = () => {
  const now = new Date();
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  return fetchFollowupsByDate(today);
};

export const saveFollowupInteraction = async (followupId: number, notes: string, outcome: string) => {
  const response = await fetch(`${API_BASE_URL}/api/followups/${followupId}`, {
    method: 'PUT',
    headers: getApiHeaders('json'),
    body: JSON.stringify({ notes, outcome }),
  });

  if (!response.ok) {
    throw new Error('Failed to save followup interaction');
  }

  return await response.json();
};
